import Swal from "sweetalert2";
import { UPDATE_DESTINATION } from "@/core/services/store/destinations.module";
import { SET_MODAL_STATE } from "@/core/services/store/modal.module";

export default {
  methods: {
    loginToInstagram(destinationId) {
      this.$store.commit(SET_MODAL_STATE, {
        modalName: "InstagramLoginForm",
        modalData: {
          id: destinationId
        },
        show: true
      });
    },
    handleCommentInstagram(destination) {
      if (destination.details.comment_status === "1") {
        destination.details.comment_status = "2";
        this.$store.dispatch(UPDATE_DESTINATION, destination).then(() => {
          Swal.fire({
            icon: "success",
            title: "کامنت ها بسته شد",
            showConfirmButton: false,
            timer: 1500
          });
        });
      } else {
        destination.details.comment_status = "1";
        this.$store.dispatch(UPDATE_DESTINATION, destination).then(() => {
          Swal.fire({
            icon: "success",
            title: "کامنت ها باز شد.",
            showConfirmButton: false,
            timer: 1500
          });
        });
      }
    }
  }
};
